import api from "./api";

// יצירת כתובת לדף התשלום של ריווחית
export const GetRivhitPaymentUrl = async (orderId) => {
  const response = await api.post(
    "RivhitPayment/get-url",
    {
      orderId: Number(orderId),
    }
  );

  return response.data;
};

// חיוב סופי - מיועד למנהל בלבד
export const ChargeFinalPayment = async (orderId) => {
  const response = await api.post(
    `RivhitPayment/${orderId}/charge-final`
  );

  return response.data;
};
export const GetRivhitPaymentStatus =
  async (orderId) => {
    const response = await api.get(
      `RivhitPayment/${orderId}/status`
    );

    return response.data;
  };